import React from "react";

import {
  Container,
  Content,
  ActionsContent,
  CancelButton,
  ConfirmButton,
  ModalConfirmText,
  RightButtons,
  CloseButton,
} from "./styles";

import { IoWarningOutline } from "react-icons/io5";
import Loading from "@components/Loading/Loading";

type Props = {
  text: string;
  option: string;
  rejectOption?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onReject?: () => void;
};

const ModalConfirm = ({
  text,
  option,
  rejectOption,
  loading,
  onCancel,
  onConfirm,
  onReject,
}: Props) => {
  return (
    <Container>
      <Content>
        <IoWarningOutline size={80} />
        <ModalConfirmText>{text}</ModalConfirmText>
      </Content>
      <ActionsContent>
        {loading ? (
          <Loading />
        ) : (
          <>
            <ActionsContent>
              <CancelButton onClick={onCancel}>
                <p>Cancelar</p>
              </CancelButton>
              <RightButtons>
                {rejectOption && (
                  <CloseButton onClick={onReject}>
                    <p>Não</p>
                  </CloseButton>
                )}

                <ConfirmButton onClick={onConfirm}>
                  <p>{option}</p>
                </ConfirmButton>
              </RightButtons>
            </ActionsContent>
          </>
        )}
      </ActionsContent>
    </Container>
  );
};

export default ModalConfirm;
